export default "__VITE_ASSET__8ec5573c__"